<template>
	<div id="app">
		<Header v-if="!$route.meta.headHide && checkRouter"></Header>
		<keep-alive><router-view v-if="$route.meta.keepAlive && isRouterAlive && checkRouter"></router-view></keep-alive>
		<router-view v-if="!$route.meta.keepAlive && isRouterAlive && checkRouter"></router-view>
		<Footer v-if="!$route.meta.footHide && checkRouter"></Footer>
	</div>
</template>
<script>
import Header from './components/common/Header.vue';
import Footer from './components/common/Footer.vue';
import { mapActions, mapState } from 'vuex';
import { apiBaseUrl } from '@/config/env.js';

import { redicectCheck, isSafeRedirect } from './utils/index.js';

export default {
	name: 'app',
	data() {
		return {
			isRouterAlive: true,
			checkRouter: false //检查路由
		};
	},
	provide() {
		return {
			reload: this.reload
		};
	},
	computed: {
		...mapState({
			shopMenu: state => state.shopMenu
		})
	},
	components: {
		Header,
		Footer
	},
	methods: {
		...mapActions(['getShopMenuAction']),
		getUrlParam(paraName) {
			const url = window.location.toString();
			const parts = url.split('?');
			if (parts.length <= 1) return '';
			for (let i = 1; i < parts.length; i++) {
				const arrPara = parts[i].split('&');
				for (let j = 0; j < arrPara.length; j++) {
					const arr = arrPara[j].split('=');
					if (arr != null && arr[0] === paraName) {
						let val = arr[1] || '';
						if (val.indexOf('#') > -1) {
							val = val.split('#')[0];
						}
						return decodeURIComponent(val);
					}
				}
			}
			return '';
		},
		recordInviteVisit() {
			const code = this.$storage.get('invitecode');
			if (!code || !this.$storage.get('userToken')) return;
			const visited_page = `${apiBaseUrl}web/`;
			this.$api.recordInviteActivityVisit({
				code,
				visited_page
			}).then(() => {
				this.$storage.remove('invitecode');
			});
		},
		reload() {
			this.isRouterAlive = false;
			this.$nextTick(function() {
				this.isRouterAlive = true;
			});
		},
		setFavicon() {
			var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
			link.type = 'image/x-icon';
			link.rel = 'shortcut icon';
			link.href = this.$store.state.config.shop_logo;
			document.getElementsByTagName('head')[0].appendChild(link);
		},
		getShopConfig() {
			// if (this.$storage.get('config')) {
			//   this.$store.dispatch('getShopConfig', this.$storage.get('config'))
			// } else {ss
			this.$api
				.shopConfig(
					{ url: apiBaseUrl }
					//{ url: 'http://localhost:8081/'}
				)
				.then(res => {
					this.$storage.set('config', res);
					this.$store.dispatch('getShopConfig', res);
				});
			// }
			this.setFavicon();
		},
		getAreaList() {
			//if (this.$storage.get('areaList')) return
			this.$api.getAreaList({}).then(res => {
				if (res.status) {
					this.$storage.set('areaList', res.data);
				}
			});
		}
	},
	created() {
		this.checkRouter = redicectCheck();
		//判断完，再检查是否登录
		if(this.checkRouter){
			let token = localStorage.getItem('userToken');
			let url = window.location.href;
			url = url.toLowerCase();
			if (!token && url.indexOf('/web/login') <= -1 && url.indexOf('/web/author') <= -1) {
				
				this.$storage.set('redirectPage',url);//跳转页面
				
				const targetUrl = '/web/login';
				if (!isSafeRedirect(targetUrl)) {
					return;
				}
				window.location.href = targetUrl;
				return;
			}
			this.getShopConfig();
			this.getAreaList();
			this.getShopMenuAction();
			this.recordInviteVisit();
			
			if (token && token.indexOf('"') == -1) {
				this.$storage.remove('userToken');
			}
		}
	},
	mounted() {
		
	}
};
</script>

<style lang="scss">
@import './assets/css/index.scss';
@import './assets/css/variable.scss';
@import './assets/css/happy.scss';
body,
html,
div,
span,
p,
li,
ul,
a,
h1,
h2,
h3 {
	font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
}
body,
html {
	min-width: 1226px;
	height: 100%;
	background: $theme-bg;
	color: #606266;
	font-size: 14px;
}
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	min-height: 100%;
	height: auto;
	display: flex;
	flex-direction: column;
}
.el-container {
	width: 100%;
}
.shop-container {
	width: 1226px;
	margin: 0 auto;
}
.error {
	font-size: 14px;
	line-height: 20px;
}
.bgw {
	background: #fff;
}
.bgc {
	background: $theme-bg;
}
.shop-container .nav-bread {
	@include line-height(40px);
	font-size: 12px;
	span {
		padding: 0 4px;
		font-size: #757575;
	}
	a:hover {
		color: #000;
	}
}
.coupon-list {
	display: flex;
	flex-flow: row wrap;
	padding: 20px 0;
}
.coupon-wrap {
	width: 300px;
	height: 100px;
	color: #fff;
	position: relative;
	margin: 10px auto;
	background: linear-gradient(to right, #ff6565, #ff8a8a);
	&:nth-child(3n + 3) {
		margin-right: 0;
	}
	&.nouse {
		background: #c3c3c3;
	}
	.content {
		flex: 1;
		height: 100px;
		position: relative;
		background: url('~@/assets/icon/semi-circle.png') no-repeat 0px center;
		.price {
			position: absolute;
			top: 15px;
			left: 20px;
			width: 80%;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
			.num {
				font-size: 18px;
			}
		}
		.desc {
			position: absolute;
			// top: 50px;
			top: 55px;
			left: 20px;
			font-size: 12px;
		}
		.time {
			position: absolute;
			bottom: 15px;
			left: 20px;
			font-size: 12px;
		}
	}
	.status {
		position: absolute;
		right: 8px;
		top: 0px;
		height: 100%;
		color: $theme-color;
		a {
			display: block;
			width: 20px;
			background: #ffe7e7;
			margin-top: 16px;
			text-align: center;
			padding: 10px 2px;
			font-size: 12px;
		}
		.icon {
			font-size: 50px;
			color: #fff;
		}
	}
}

.el-dialog {
	.el-dialog__header {
		background: #ffc300 !important;
	}
}
.displayBet {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
</style>
